<template>
  <v-card class="secondarybackground" height="180" style="overflow-y: auto;">
    <v-card-text class="caption">
      <div class="font-weight-bold subtitle-2 ml-5 mb-2 font-italic">
        {{ item.technical_inventory_code }} -
        {{ item.technical_inventory_name }}
      </div>
      <div v-for="line in item.children" :key="line.technical_inventory_code">
        {{ line.technical_inventory_code }} -
        {{ line.technical_inventory_name }} ({{ line.etat }})
        <span class="font-italic">{{ line.comment }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TechInventoryCard',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
